import React from "react";

const AlsStudyAbastract = () => {
  return (
    <div className="als-study-abstracts-div">
      <p className="main-heading">ALS STUDIES AND ABSTRACTS</p>
      <div>
        <ul>
          {/* Temporarily commented out MUSCLE & NERVE publication
          <li>
            <p className="publication-nurve-text">
              <span style={{ fontWeight: "600" }}>Publication:</span>{" "}
              <span>MUSCLE & NERVE</span>
            </p>
            <a
              href="https://onlinelibrary.wiley.com/doi/10.1002/mus.27991"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3 className="heading">
                Identifying amyotrophic lateral sclerosis through interactions
                with an internet search engine
                <i
                  className="fas fa-link"
                  style={{
                    paddingLeft: 7,
                    fontSize: 17,
                  }}
                ></i>
              </h3>
            </a>
            <p className="author-name">
              Elad Yom-Tov PhD, Indu Navar MSCS, Ernest Fraenkel PhD, James D.
              Berry MD, MPH
            </p>
            <p className="published-on">
              <span>
                Published on: <span>25 October 2023</span>
              </span>
            </p>
          </li>
          */}

        </ul>
        <button
          className="btn btn-outline-primary btn-lg"
          style={{
            borderColor: "#1A4F83",
            color: "#1A4F83",
            fontWeight: "bold",
            fontSize: "16px",
            padding: "12px 24px",
            borderRadius: "8px",
            backgroundColor: "white",
          }}
          onClick={() => window.open("https://www.everythingals.org/publications", "_blank")}
        >
          <i className="fas fa-book me-2"></i>
          Publications
        </button>
      </div>
    </div>
  );
};

export default AlsStudyAbastract;
